<div appModal (closeModal)="close()">
  <form [formGroup]="athleteForm">
    <section class="modal-title-container">
      <div class="modal--title">New Athlete</div>
      <div class="modal--subtitle">Fill out the athlete info below to add an athlete</div>
    </section>

    <section class="modal-content-container">
      <div *ngIf="!event.isTeamPackage || (event.isTeamPackage && currentUser.type === USER_TYPES.PARENT)">
        <label class="input-title">Full name</label>
        <div class="input input-text" [class.input-error]="formHelpersService.isInputInvalid(athleteForm, 'fullName')">
          <input type="text" formControlName="fullName" name="full_name" />
        </div>
      </div>

      <div>
        <label class="input-title" *ngIf="availableGradYears?.length">Graduation year</label>
        <ng-select
          *ngIf="availableGradYears?.length"
          [items]="availableGradYears"
          bindLabel="name"
          bindValue="value"
          appendTo="body"
          [clearable]="false"
          [searchable]="false"
          formControlName="gradYear"
          [class.input-error]="formHelpersService.isInputInvalid(athleteForm, 'gradYear')"
        >
        </ng-select>
      </div>

      <div *ngIf="event?.event?.eventType === EVENT_TYPES.TEAM || event?.isTeamPackage">
        <label class="input-title">Team name</label>
        <div class="input input-text" [class.input-error]="formHelpersService.isInputInvalid(athleteForm, 'teamName')">
          <input type="text" formControlName="teamName" name="team_name" />
        </div>
      </div>

      <div>
        <label class="input-title">Email</label>
        <div class="input input-text" [class.input-error]="formHelpersService.isInputInvalid(athleteForm, 'email')">
          <input type="text" formControlName="email" name="email" />
        </div>
      </div>
    </section>

    <p class="text-sienna text-center" *ngIf="showInvalidMessage">Please fill all mandatory fields</p>
    <section class="modal-actions-container">
      <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
      <button alt="Submit" class="btn btn-lg" (click)="setAthlete()">Add Athlete</button>
    </section>
  </form>
</div>
